// extracted by mini-css-extract-plugin
module.exports = {"container":"commentary_subtitle-module__container--3NcOP","highlight":"commentary_subtitle-module__highlight--21fmy"};